import React from 'react';
import InputComponent from '../input/Input';
import ToggleComponent from '../toggle/Toggle';
import Choice from '../choice/Choice';
import { ToggleElement } from '../../schema/toggle.schema';
import { ChoiceElement } from '../../schema/choice.schema';
import { InputElement } from '../../schema/input.schema';
import { SwitchableElement } from '../../schema/switchable.schema';
import SwitchableComponent from '../switchable/Switchable';
import TextComponent from '../text/Text';
import { TextElement } from '../../schema/text.schema';
import LinkComponent from '../link/Link';
import { LinkElement } from '../../schema/link.schema';
import ImageComponent from '../image/Image';
import { ImageElement } from '../../schema/image.schema';
import ContextComponent from '../context/Context';
import { ContextElement } from '../../schema/context.schema';
import { FormElement } from '../../schema/form.schema';
import { FormDataValue } from '../../hooks/useFormData';

interface FormElementProps {
	element: FormElement;
	onChange: (key: string, value: FormDataValue) => void;
	onValidationChange: (key: string, value: boolean) => void;
}

const FormElementComponent: React.FC<FormElementProps> = ({ element, onChange, onValidationChange }) => {
	switch (element.type) {
		case 'input':
			return (
				<InputComponent
					key={element.key}
					element={element as InputElement}
					onChange={onChange}
					onValidationChange={onValidationChange}
				/>
			);
		case 'choice':
			return (
				<Choice
					key={element.key}
					element={element as ChoiceElement}
					onChange={onChange}
					onValidationChange={onValidationChange}
				/>
			);
		case 'toggle':
			return (
				<ToggleComponent
					key={element.key}
					element={element as ToggleElement}
					onChange={onChange}
					onValidationChange={onValidationChange}
				/>
			);
		case 'switchable':
			return (
				<SwitchableComponent
					key={element.key}
					element={element as SwitchableElement}
					onChange={onChange}
					onValidationChange={onValidationChange}
				/>
			);
		case 'text':
			return <TextComponent key={element.key} element={element as TextElement} />;
		case 'link':
			return <LinkComponent key={element.key} element={element as LinkElement} />;
		case 'image':
			return <ImageComponent key={element.key} element={element as ImageElement} />;
		case 'context':
			return (
				<ContextComponent
					key={element.key}
					element={element as ContextElement}
					onChange={onChange}
					onValidationChange={onValidationChange}
				/>
			);
		default:
			return null;
	}
};

export default FormElementComponent;
